import { useContext, useEffect, useState } from "react";
import { AppContext } from "@/AppContext";
import { useParams } from "react-router-dom";
import { getActiveTabFromLocalStorage } from "@/ui/TabsComponent/TabsComponent";

import { Page } from "@/ui/Layout/Page";
import { TabsComponent } from "@/ui/TabsComponent";
import Button from "@/ui/Button";
import { ButtonTypes, Variants } from "@/ui/types";
import { DashboardPage } from "@/Apps/Dashboards/DashboardPage";
import { SitePages } from "./SitePages";
import { PublishHtmlModal } from "./PublishHtmlModal";
import { getPagesInCampaign } from "@/Apps/Funnels/widgets/PageList";
import { getCampaign } from "@/api/campaigns";
import { Settings } from "@/Apps/Dashboards/Settings/Settings";
import { getSessionToken } from "@/api/auth";
import { PublishCampaignModal } from "../Funnels/Popups/PublishCampaignModal";
import { ContactsGallery } from "@/Apps/CRM/ContactsGallery";
import { getFilterObject } from "@/Apps/CRM/scripts";

export const Dashboard = ({ name = "" }) => {
  const [activeTab, setActiveTab] = useState(getActiveTabFromLocalStorage() || "overview");
  const [siteData, setSiteData] = useState<{ name?: string; id?: string; settings?: any }>({ name: "" });
  const { permissions = [] } = useContext(AppContext) as any;
  const canMedia = permissions.includes("media") || permissions.includes("admin");
  const [isPublishPopupOpen, setIsPublishPopupOpen] = useState(false);
  // const [activePageId, setActivePageId] = useState(null);
  const { id } = useParams();

  // Fetch the campaign data from the API when the component mounts
  const loadSite = async () => {
    const data = await getCampaign({ token: getSessionToken(), id });
    setSiteData(data);
  };
  useEffect(() => {
    loadSite();
  }, []);

  // Use this to configure what shows in the top bar of the page
  const topBarSettings = {
    page: [{ label: name, href: "/sites" }, { label: siteData.name || "" }],
    items: (
      <Button
        label="Publish Website"
        onClick={() => setIsPublishPopupOpen(true)}
        type={ButtonTypes.OUTLINED}
        variant={Variants.INFO}
      />
    ),
  };

  return (
    <Page topBar={topBarSettings}>
      {/* Render the publish campaign modal if it's set to open */}
      {isPublishPopupOpen && (() => {
        // AMB-698: HTML pages publish the new way (checklist); drag-and-drop pages as before.
        const objs: any[] = getPagesInCampaign(siteData as any) || [];
        const html = objs.filter((o) => o?.page?.type === "html").map((o) => ({ id: o.page.id, name: o.name, slug: o.page.slug }));
        const builderCount = objs.length - html.length;
        return html.length ? (
          <PublishHtmlModal
            pages={html}
            siteAddress={(siteData as any)?.domain?.name}
            campaignId={id}
            builderPageCount={builderCount}
            setIsOpen={setIsPublishPopupOpen}
            onPublished={() => window.location.reload()}
          />
        ) : (
          <PublishCampaignModal setIsOpen={setIsPublishPopupOpen} campaignId={id} unitName="Website" />
        );
      })()}
      <div className={`p-6 w-full`}>
        <div className="tabs flex flex-col">
          <TabsComponent
            tabs={[
              { label: "Dashboard", value: "overview" },
              // { label: "Smart Canvas", value: "canvas" }, // consider multi-view
              { label: "Contacts", value: "crm" },
              // { label: "Media", value: "media" },
              { label: "Settings", value: "settings" },
            ]}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            actionSection={false}
          />
          {activeTab === "overview" && (
            <div className="flex flex-col gap-7">
              <DashboardPage campaignData={siteData} unitName="site page" widgets={["kpi"]} />
              <SitePages campaignData={siteData} onChanged={loadSite} />
              {canMedia && <DashboardPage campaignData={siteData} unitName="site page" widgets={["media"]} />}
            </div>
          )}
          {activeTab === "canvas" && <div>Smart Canvas</div>}
          {activeTab === "crm" && (
            <ContactsGallery
              onCreate={() => {}}
              defaultFilter={getFilterObject({
                field: "hiddenTags",
                operator: "contains",
                value: id,
              })}
            />
          )}
          {activeTab === "media" && <div>Media</div>}
          {activeTab === "settings" && (
            <Settings 
              campaignData={siteData} 
              setCampaignData={setSiteData}
              unitName="Site" 
            />
          )}
        </div>
      </div>
    </Page>
  );
};
